import type { Tier } from "@agencylens/shared";

/**
 * Format a tier value as a human display label.
 *
 * Robust to a malformed session/`/license/me` payload where `tier` arrives as
 * a number (e.g. `3`) instead of the canonical `"tier-3"` string — calling
 * `.replace()` on that number is what blanked the dashboard. Always returns a
 * string (or null when there's no tier to show), never throws.
 *
 *   "tier-3" → "tier 3"   |   3 → "tier 3"   |   "3" → "tier 3"
 *   null/undefined/"" → null (caller hides the badge)
 */
export function formatTier(
  tier: Tier | number | string | null | undefined,
): string | null {
  if (tier === null || tier === undefined) return null;
  const s = String(tier).trim();
  if (!s) return null;
  const digits = s.match(/\d+/);
  return digits ? `tier ${digits[0]}` : s.replace(/-/g, " ");
}
